import { render } from "./ProjectManager.vue?vue&type=template&id=1529b972&scoped=true"
import script from "./ProjectManager.vue?vue&type=script&lang=js"
export * from "./ProjectManager.vue?vue&type=script&lang=js"

import "./ProjectManager.vue?vue&type=style&index=0&id=1529b972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1529b972"]])

export default __exports__